import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

//GSAP Animatioins

export const heroTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        // scrollTrigger: {
        //     trigger: '.hero',
        //     start: 'top center',
        //     end: '+=500',
        // },
    });
    timeline.from('.hero .hero-content h2', { opacity: 0, x: '-100px', duration: 0.7, ease: 'ease.in' });
    timeline.from('.hero .hero-content h6', { opacity: 0, x: '-100px', duration: 0.5, ease: 'ease.in' }, '-=0.2');
    timeline.from('.hero .hero-content .find-link', { opacity: 0, x: '-100px', ease: 'ease.in' }, '-=0.3');
    timeline.from('.hero .btn-groups', { opacity: 0, x: '-100px' }, '-=0.5');
    timeline.fromTo('.hero .hero-mockup .circle-layer', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=1.2');
    timeline.fromTo(
        '.hero .hero-mockup .circle-outer-layer',
        { opacity: 1, scale: 0.7 },
        { opacity: 0, scale: 1, repeat: -1, duration: 1, ease: 'ease.in' },
        '-=1.1',
    );
    timeline.fromTo('.hero .hero-mockup .hero-frame', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
    timeline.fromTo('.hero .hero-mockup .frame-block', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
};

export const aboutUsTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.gsap-about',
            start: 'top 80%',
        },
    });
    timeline.from('.gsap-about .section-title', 0.5, { opacity: 0, x: '100px' });
    timeline.staggerFrom(
        '.gsap-about ul li',
        0.3,
        {
            opacity: 0,
            x: '100px',
        },
        0.08,
    );
    timeline.from('.gsap-about button', 0.2, { opacity: 0, x: '100px' }, '-=0.2');
    timeline.fromTo(
        '.gsap-about .block-layer .top',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, repeat: -1, duration: 1.4, yoyo: true },
        '-=1',
    );
    timeline.fromTo(
        '.gsap-about .block-layer .bottom',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, repeat: -1, duration: 1.4, yoyo: true },
        '-=1',
    );
    timeline.fromTo('.gsap-about .color-layer', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
    timeline.fromTo('.gsap-about .color-layer > *', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.5');
};

export const howItWorksTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.how-it-works',
            start: 'top 80%',
        },
    });
    timeline.from('.how-it-works .section-title', { opacity: 0, y: '100%' });
    timeline.from('.how-it-works .primary-slider .slick-track > *', {
        duration: 0.8,
        opacity: 0,
        y: 40,
        stagger: {
            amount: 0.1,
        },
    });
    timeline.from('.how-it-works .primary-slider .slick-arrow.slick-prev svg', { opacity: 0 }, '-=0.2');
    timeline.from('.how-it-works .primary-slider .slick-arrow.slick-next svg', { opacity: 0 }, '-=0.2');
};

export const comparisonTableTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.comparison-table',
            start: 'top 80%',
        },
    });
    timeline.from('.comparison-table .section-title', { opacity: 0, y: '100px', duration: 0.5 });
    timeline.from('.comparison-table .custom-table', { opacity: 0, y: '100px' }, '-=0.3');
};

export const practiceWithUsTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.practice-with-us',
            start: 'top 80%',
        },
    });
    timeline.from('.practice-with-us .section-title', { opacity: 0, x: '-100px', duration: 0.5 });
    timeline.from('.practice-with-us .section-info', { opacity: 0, x: '-100px' }, '-=0.3');
    timeline.fromTo(
        '.practice-with-us .block-layer .top',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, repeat: -1, duration: 1.4, yoyo: true },
        '-=1',
    );
    timeline.fromTo(
        '.practice-with-us .block-layer .bottom',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, repeat: -1, duration: 1.4, yoyo: true },
        '-=1',
    );
    timeline.fromTo(
        '.practice-with-us .color-layer .main-mockup',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1 },
        '-=0.8',
    );
    timeline.fromTo(
        '.practice-with-us .color-layer .frame-block',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1 },
        '-=0.6',
    );
    timeline.fromTo('.practice-with-us .accordion-block', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.4');
};

export const otherFrameworksTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.other-frameworks',
            start: 'top 80%',
        },
    });
    timeline.from('.other-frameworks .section-info', { opacity: 0, x: '100%' });
    timeline.staggerFrom(
        '.other-frameworks .logo-block',
        0.3,
        {
            opacity: 0,
            x: '100%',
        },
        0.08,
    );
};

export const testimonialsTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.testimonials',
            start: 'top 80%',
        },
    });
    timeline.from('.testimonials .section-title', { opacity: 0 });
    timeline.from('.testimonials .slider-block .MuiTypography-body1', { opacity: 0 });
    timeline.fromTo(
        '.testimonials .block-layer .top',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1',
    );
    timeline.fromTo(
        '.testimonials .block-layer .bottom',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1',
    );
    timeline.fromTo('.testimonials .custom-grid img', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
};

export const joinUsTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.join-us',
            start: 'top 80%',
        },
    });
    timeline.from('.join-us .section-title', { opacity: 0, duration: 0.5, x: '-100px' });
    timeline.from('.join-us .section-info', { opacity: 0, x: '-100px' }, '-=0.3');
    timeline.from('.join-us .form', { opacity: 0, x: '-100px' }, '-=0.3');
    timeline.from('.join-us .MuiButtonBase-root', { opacity: 0, x: '-100px' }, '-=0.3');
    timeline.fromTo(
        '.join-us .block-layer .top',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1.2',
    );
    timeline.fromTo(
        '.join-us .block-layer .bottom',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1.2',
    );
    timeline.fromTo('.join-us .color-layer', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
    timeline.fromTo('.join-us .color-layer .main-mockup', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.2');
};

export const knowMoreTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.know-more',
            start: 'top 80%',
        },
    });
    timeline.from('.know-more .section-title', { opacity: 0, y: '100%' });
    timeline.from('.know-more .MuiButtonBase-root', { opacity: 0, y: '100%' });
};

export const whyUsTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.why-us',
            start: 'top 80%',
        },
        ease: 'ease.in',
    });
    timeline.from('.why-us .section-title', 0.5, { opacity: 0, x: '-100px' });
    timeline.from('.why-us .section-info', 0.5, { opacity: 0, x: '-100px' }, '-=0.3');
    timeline.staggerFrom(
        '.why-us ul li',
        0.3,
        {
            opacity: 0,
            x: '-100px',
        },
        0.08,
    );
    timeline.fromTo(
        '.why-us .block-layer .top',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1.7',
    );
    timeline.fromTo(
        '.why-us .block-layer .bottom',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1.7',
    );
    timeline.fromTo('.why-us .color-layer > *', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
};

export const accessServiceTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.access-service',
            start: 'top 80%',
        },
        ease: 'ease.in',
    });
    timeline.from('.access-service .section-title', 0.5, { opacity: 0, y: '100px' });
    timeline.fromTo(
        '.access-service .block-layer .top',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1',
    );
    timeline.fromTo(
        '.access-service .block-layer .bottom',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 1.4, repeat: -1, yoyo: true },
        '-=1',
    );
    timeline.fromTo('.access-service .color-layer', { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 }, '-=0.8');
    timeline.fromTo(
        '.access-service .color-layer .main-mockup',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1 },
        '-=0.2',
    );
    timeline.from('.access-service .access-service-content', { opacity: 0, x: '100px' }, '-=0.5');
};

export const faqTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.faq',
            start: 'top 80%',
        },
    });
    timeline.from('.faq .section-title', 0.5, { opacity: 0, y: '100%' });
    timeline.from('.faq .accordion-block', 0.5, { opacity: 0, y: '100%' }, '-=0.4');
};

export const footerTimeLineObj = (animation) => {
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.footer',
            start: 'top bottom',
        },
        ease: 'ease.in',
    });
    timeline.from('.footer .portal-info', { opacity: 0, x: '-100px' });
    timeline.from('.footer .link-wrapper', { opacity: 0, x: '+100px' });
};
